var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('server-connect',{style:(_vm.cssVars),attrs:{"lang":_vm.lang},on:{"ready":_vm.setRemoteId}},[_c('ConfigModal'),(!_vm.raceNotLoaded || _vm.isCamera)?_c('router-view'):_vm._e(),(_vm.raceNotLoaded && !_vm.disablePreraceMessages)?_c('Wait'):_vm._e(),(_vm.devMode)?_c('DevPanel'):_vm._e(),_c('round-alert'),_c('speech')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }